import { Typography } from "@mui/material";
import { ReactElement } from "react";

import { CampaignListResult } from "~frontend/__generated__/graphql";
import { InternalLink } from "~frontend/components/Link";
import Table from "~frontend/components/Table";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";
import { CAMPAIGN_STATUSES } from "~frontend/routes/subaccounts/campaignsList/constants";

export default function FollowUpCampaignSelectorTable({
  rows,
  totalCount,
  page,
  setPage,
  pageSize,
  setPageSize,
  selectedCampaignIds,
  selectedCampaigns,
  setSelectedCampaigns,
  readOnly,
  footerActions,
}: {
  rows: CampaignListResult[];
  totalCount: number;
  page: number;
  setPage: (newPage: number) => void;
  pageSize: number;
  setPageSize: (newPageSize: number) => void;
  selectedCampaignIds: string[];
  selectedCampaigns: CampaignListResult[];
  setSelectedCampaigns: (selectedRows: string[]) => void;
  readOnly?: boolean;
  footerActions: React.ReactNode;
}): ReactElement {
  const { subaccountLink } = useSubaccount()!;

  return (
    <>
      <Table
        totalCount={totalCount}
        page={page}
        onChangePage={setPage}
        rowsPerPage={pageSize}
        onChangeRowsPerPage={setPageSize}
        rows={[...selectedCampaigns, ...rows]}
        emptyState="No campaigns found"
        noFooter={readOnly}
        selectedRows={selectedCampaignIds}
        selectDisabled={readOnly}
        onChangeSelectedRows={setSelectedCampaigns}
        columns={[
          {
            key: "campaignName",
            title: "Campaign",
            renderValue: row => (
              <>
                <InternalLink
                  to={subaccountLink(`/campaigns/${row.shortId}`)}
                  target="_blank"
                >
                  <Typography variant="body2" component={"span"}>
                    {row.name}
                  </Typography>
                </InternalLink>
                <Typography variant="body3" component={"div"}>
                  Campaign ID: #{row.shortId}
                </Typography>
              </>
            ),
          },
          {
            key: "status",
            title: "Status",
            renderValue: row =>
              CAMPAIGN_STATUSES.find(s => s.value === row.status)?.label,
          },
          {
            key: "createdAt",
            title: "Created",
            renderValue: row => new Date(row.createdAt).toLocaleString(),
          },
          {
            key: "lastMessaged",
            title: "Last Initial",
            renderValue: row =>
              row.statsForList?.lastMessagedAt
                ? new Date(row.statsForList?.lastMessagedAt).toLocaleString()
                : "",
          },
        ]}
        footerActions={footerActions}
        reverseFooterOrder={true}
      />
    </>
  );
}
